/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useState, useEffect } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import useStyles from "../../styles";
import { Grid, Button } from "@material-ui/core";
import { getTitleFooter } from "../configVerifyDevice";

const VerifyDevicePage = props => {
	const { type, onConfirm } = props;
	const classes = useStyles();
	const [isDisable, setDisable] = useState(false);

	useEffect(() => {
		return () => {
			setDisable(false);
		};
	}, []);

	return (
		<Grid classes={{ root: classes.rootFooter }}>
			<Button
				type="submit"
				classes={{
					root: classes.btnSubmit,
					disabled: classes.disabledBtn
				}}
				disabled={isDisable}
				onClick={() => {
					onConfirm();
					if (["NEW_APPROVED", "REJECTED", "LOCKED"].includes(type)) {
						setDisable(true);
					}
				}}
			>
				{isDisable && (
					<CircularProgress
						style={{
							height: 20,
							width: 20,
							marginRight: 5,
							color: "#ffffff"
						}}
					/>
				)}
				{getTitleFooter(type)}
			</Button>
		</Grid>
	);
};

export default memo(VerifyDevicePage);
